// 统一环境配置（手动切换）
// 可选值: 'dev' | 'test' | 'prod'
// 修改此值以切换环境：'dev' | 'test' | 'prod'
export const ENV = 'prod';

export const ENV_CONFIG = {
  dev:   { BASE_URL: 'http://localhost:8666' },
  test:  { BASE_URL: 'https://dev.cross1000.com' },
  prod:  { BASE_URL: 'https://dev.cross1000.com' }
};

// 若需新增环境，在此对象中添加。例如：
// staging: { BASE_URL: 'http://staging-server:8666' }
